<template>
  <div></div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as xhr from '../api/xhr.js'
import * as qconst from '../vendor/qconstants'

export default {
  name: "NewsLifecycle",
  created() {
    ebus.$on('loadNews', (force) => {
      this.loadNews();
    });
  },
  destroyed() {
  },
  beforeMount() {
  },
  methods: {
    async loadNews() {
      console.log('loadNews');
      let msg = {
        action: qconst.action$LoadDocs,
        collectionName: 'news',
        query: {
          active: true,
        }
      };
      await xhr.xhrSend(true, msg, (data) => {
        if (data && data.ok && data.docs && Array.isArray(data.docs)) {
          let docs = data.docs;
          console.log('number of news: ' + docs.length);

          if (docs.length > 0) {
            store.commit('news', docs);
          }
        } else {
          console.log('error loading news');
        }
      });
    },

  }
}
</script>

<style scoped>

</style>
